import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { VitalService } from 'src/app/shared/services/vital.service';
import { pieChartOption } from './graphconstants';

@Component({
  selector: 'app-vital-results',
  templateUrl: './vital-results.component.html',
  styleUrls: ['./vital-results.component.scss']
})
export class VitalResultsComponent implements OnInit {

  page : "details" | "engines" | "links" = "engines";

  pieChartOptions = JSON.parse(JSON.stringify(pieChartOption))
  Highcharts: typeof Highcharts = Highcharts;
  updateFlag = true;
  updateDonutFlag = true;

  allEnginesNames = ['avira', 'bitdefender', 'clamav', 'comodo', 'drweb', 'eset', 'fsecure', 'kaspersky', 'mdatp', 'mfetp', 'sophos', 'trend', 'yara', 'yara_45283']
  enginesScan : {name: string, version: string, analysisDate:Date, updateDate:string, error?:string}[]
  vitalLinks : string[] = [];
  vitalBasicProperties : {
    md5: string;
    sha1: string;
    sha256: string;
    ssdeep: string;
    mimeType: string;
    mimeEncoding: string;
    fileSize: number;
  } | null
  vitalHistory : {
    firstSubmission : Date;
    lastSubmission : Date;
    lastAnalysis : Date;
  } | null
  vitalNames : string[] | null;
  vitalExifTools : {name:string, value :string}[] | null;
  vitalTrid : string[] | null;

  analysisPending = false;
  scanSuccess = true;
  signaturesClean : number;
  signaturesInfected : number;

  hash: string;
  scanNotFound: boolean;

  constructor(private vitalService : VitalService, private route: ActivatedRoute, private router: Router  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.hash = params['uploadId']
      const record = this.vitalService.getLocalRecord(this.hash)
      if( record == null) {
        this.scanNotFound = true;
      }
      else {
        this.vitalLinks= record?.link;
        this.vitalBasicProperties = {
          md5: record.fileinfo.MD5,
          sha1: record.fileinfo.SHA1,
          sha256: record.fileinfo.SHA256,
          ssdeep: record.fileinfo.ssdeep,
          mimeType: record.fileinfo['mime-type'],
          mimeEncoding: record.fileinfo['mime-encoding'],
          fileSize: record.fileinfo.size,
        }
        this.vitalHistory = {
          firstSubmission : new Date(record.meta.dateSubmissionFirst),
          lastSubmission : new Date(record.meta.dateSubmissionLast),
          lastAnalysis : new Date(record.meta.dateAnalyseLast),
        };
        this.vitalExifTools= record.fileinfo.exifTools;
        this.vitalNames= record.meta.filenames;
        this.vitalTrid = record.fileinfo.trid;
        this.enginesScan = [];
        Object.keys(record).forEach(key => {
          if(this.allEnginesNames.includes(key)) {
            const engine = record[key];
            this.enginesScan.push({
              name: key,
              version : engine.engine,
              updateDate : engine.update,
              analysisDate : new Date(engine.dateAnalyseLast),
              error : engine.error ? "Trojan.AndroidOS.1234" : null
            })
          }
        })

        // result chart
        this.signaturesInfected = this.enginesScan?.filter(s => s.error != null).length ?? 0;
        this.signaturesClean = this.enginesScan?.filter(s => s.error == null).length ?? 0;
        let pieSeries : any = {};
        pieSeries.innerSize = '75%';
        pieSeries.colorByPoint = true;
        pieSeries.data = [
          {name : "red", y:this.signaturesInfected, color: 'red'},
          {name : "grey", y:this.signaturesClean, color : this.signaturesInfected > 0 ? "grey" : "green"},
        ]
        this.pieChartOptions.series[0] = pieSeries;
        this.pieChartOptions.title.text = `${this.signaturesInfected}/${Math.max(this.signaturesInfected+this.signaturesClean,1)}`
        this.pieChartOptions.subtitle.text = this.signaturesInfected > 0 ? "INFECTED" : "CLEAN";
      }
    });


  }

  /* trigger a rescan of the file */
  rescan() {
    console.log('rescan');
  }

  /* reload the page */
  reload(id :string) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() { return false; };
    this.router.navigateByUrl(`/updates/services/certtools/vitalresults/${id}`);
    this.ngOnInit();
  }

  /* check if a date is well defined */
  isDateDefined(d: Date | Number | Object) {
    //console.log(`"${String(d)}"`);
    return d && `"${String(d)}"` != "Invalid Date"
/*     if(d instanceof Date) {
      return d != null && !isNaN(d.getTime());
    }
    if(d instanceof Number){
      return !isNaN(Number(d));
    }
    if(typeof d == 'object') {
      return String(d) != 'Invalid Date'
    } */
    return false;
  }

}
